/**
 * Module « ventes » — le guichet de Luc (VEN-01 à VEN-05).
 *
 * Deux écrans, montés sous `/admin/ventes` par le routeur de la fondation
 * (ARCHITECTURE §11 : ce fichier est le seul point de contact) :
 *
 *   /admin/ventes            vente au guichet et invitations, sur le plan de salle
 *   /admin/ventes/journal    ventes de la journée, totaux de clôture, corrections
 *
 * La représentation en cours de vente voyage dans l’URL (`?r=…`) : recharger la
 * page ou ouvrir un second onglet ne fait rien perdre.
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

const PagePromotions = lazy(() =>
  import('../promotions/PagePromotions').then((m) => ({ default: m.PagePromotions })),
)
const PageImpressions = lazy(() =>
  import('../impressions/PageImpressions').then((m) => ({ default: m.PageImpressions })),
)
const PageBons = lazy(() => import('../bons/PageBons').then((m) => ({ default: m.PageBons })))
const FicheBon = lazy(() => import('../bons/PageBons').then((m) => ({ default: m.FicheBon })))

// Feature lourde (le guichet, VEN-01 à VEN-05) : chaque écran a son propre
// chunk (ARCHITECTURE §9.4). Le `<Suspense>` de repli vit dans `LayoutAdmin`.
const PageSecours = lazy(() =>
  import('./secours/PageSecours').then((m) => ({ default: m.PageSecours })),
)
const PageVente = lazy(() => import('./PageVente').then((m) => ({ default: m.PageVente })))
const PageJournal = lazy(() => import('./PageJournal').then((m) => ({ default: m.PageJournal })))

const PageGroupes = lazy(() =>
  import('./groupes/PageGroupes').then((m) => ({ default: m.PageGroupes })),
)
const PageGroupe = lazy(() =>
  import('./groupes/PageGroupe').then((m) => ({ default: m.PageGroupe })),
)
const CreerGroupeForm = lazy(() =>
  import('./groupes/CreerGroupeForm').then((m) => ({ default: m.CreerGroupeForm })),
)

const PageListeAttente = lazy(() =>
  import('./attente/PageListeAttente').then((m) => ({ default: m.PageListeAttente })),
)

const PageDemandes = lazy(() =>
  import('../demandes/PageDemandes').then((m) => ({ default: m.PageDemandes })),
)
const DossierDemande = lazy(() =>
  import('../demandes/DossierDemande').then((m) => ({ default: m.DossierDemande })),
)
export const routesVentes: RouteObject[] = [
  { path: 'demandes', element: <PageDemandes staff /> },
  { path: 'demandes/:id', element: <DossierDemande staff /> },
  { index: true, element: <PageVente /> },
  { path: 'journal', element: <PageJournal /> },
  { path: 'secours', element: <PageSecours /> },
  { path: 'attente', element: <PageListeAttente /> },
  { path: 'bons', element: <PageBons /> },
  { path: 'promotions', element: <PagePromotions /> },
  { path: 'impressions', element: <PageImpressions /> },
  { path: 'bons/:id', element: <FicheBon /> },
  { path: 'groupes', element: <PageGroupes /> },
  { path: 'groupes/nouveau', element: <CreerGroupeForm /> },
  { path: 'groupes/:id', element: <PageGroupe /> },
]

export { PageJournal, PageVente }
